<mat-card id="page-content">
    <mat-card-content>
        <form [formGroup]="form" class="form-container">
            <!-- Group Name -->
            <div class="group-select-row">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'GROUP_NAME' | translate }}</mat-label>
                    <mat-select formControlName="groupId" size="small">
                        <input id="search-select" class="w-100 border-0 p-1"
                            (input)="filteredgroupsList=onFilteredListSearch($event, groupsList, 'name')"
                            placeholder="Search {{ 'GROUP_NAME' | translate }}" />
                        @for (ct of filteredgroupsList; track ct) {
                        <mat-option [value]="ct.groupId">{{ ct.name }}</mat-option>
                        }
                    </mat-select>
                    @if (f['groupId'].errors) {
                    <mat-error>
                        @if (f['groupId'].errors['required']) {
                        <span>{{ 'FIELD_REQUIRED' | translate }}</span>
                        }
                    </mat-error>
                    }
                </mat-form-field>
            </div>

            @if (f['groupId'].value) {
            <!-- Action Bar -->
            <div class="action-bar">
                @if (hasUnsavedChanges) {
                <span class="unsaved-indicator">Unsaved changes</span>
                <button class="btn-discard" (click)="discardChanges()">Discard</button>
                }
                <button class="btn-update" [disabled]="!hasUnsavedChanges" (click)="updateRights()">Update Rights</button>
            </div>

            <!-- WORKFLOW STEPS -->
            <div class="rights-section">
                <div class="section-header bg-process">
                    <span class="section-title">{{'WORK_FLOW_STEPS' | translate}}</span>
                </div>
                <div class="section-body">
                    <div class="panel">
                        <div class="panel-header">
                            <span class="panel-label">Available</span>
                            <span class="panel-count">({{displayWorkFlowStepsList.length}})</span>
                        </div>
                        <input class="panel-search" placeholder="Search rights..."
                            [(ngModel)]="availableSearchProcess" [ngModelOptions]="{standalone: true}" />
                        <div class="panel-list">
                            @for (item of filterBySearch(displayWorkFlowStepsList, availableSearchProcess); track item) {
                            <div class="list-item" [class.checked]="isCheckedAvailable(item, PROCESS)" (click)="toggleAvailableCheck(item, PROCESS)">
                                <span class="item-check"></span>
                                <span>{{item.name}}</span>
                            </div>
                            }
                        </div>
                        <div class="panel-footer">
                            <a class="action-link add-link" (click)="selectAll(PROCESS)">Add All &rarr;</a>
                        </div>
                    </div>
                    <div class="transfer-controls">
                        <button class="arrow-btn arrow-right" (click)="moveToAssigned(PROCESS)">&rsaquo;</button>
                        <button class="arrow-btn arrow-left" (click)="moveToAvailable(PROCESS)">&lsaquo;</button>
                    </div>
                    <div class="panel">
                        <div class="panel-header">
                            <span class="panel-label">Assigned</span>
                            <span class="panel-count-badge badge-process">{{selectedWorkFlowStepsList.length}}</span>
                        </div>
                        <input class="panel-search" placeholder="Search assigned..."
                            [(ngModel)]="assignedSearchProcess" [ngModelOptions]="{standalone: true}" />
                        <div class="panel-list">
                            @for (item of filterBySearch(selectedWorkFlowStepsList, assignedSearchProcess); track item) {
                            <div class="list-item" [class.checked]="isCheckedAssigned(item, PROCESS)" (click)="toggleAssignedCheck(item, PROCESS)">
                                <span class="item-check"></span>
                                <span>{{item.name}}</span>
                            </div>
                            }
                        </div>
                        <div class="panel-footer">
                            <a class="action-link remove-link" (click)="removeAll(PROCESS)">&larr; Remove All</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- DIVISION -->
            <div class="rights-section">
                <div class="section-header bg-division">
                    <span class="section-title">{{'DIVISION' | translate}}</span>
                </div>
                <div class="section-body">
                    <div class="panel">
                        <div class="panel-header">
                            <span class="panel-label">Available</span>
                            <span class="panel-count">({{displayDivisionList.length}})</span>
                        </div>
                        <input class="panel-search" placeholder="Search rights..."
                            [(ngModel)]="availableSearchDivision" [ngModelOptions]="{standalone: true}" />
                        <div class="panel-list">
                            @for (item of filterBySearch(displayDivisionList, availableSearchDivision); track item) {
                            <div class="list-item" [class.checked]="isCheckedAvailable(item, adminStructure.DIVISION)" (click)="toggleAvailableCheck(item, adminStructure.DIVISION)">
                                <span class="item-check"></span>
                                <span>{{item.name}}</span>
                            </div>
                            }
                        </div>
                        <div class="panel-footer">
                            <a class="action-link add-link" (click)="selectAll(adminStructure.DIVISION)">Add All &rarr;</a>
                        </div>
                    </div>
                    <div class="transfer-controls">
                        <button class="arrow-btn arrow-right" (click)="moveToAssigned(adminStructure.DIVISION)">&rsaquo;</button>
                        <button class="arrow-btn arrow-left" (click)="moveToAvailable(adminStructure.DIVISION)">&lsaquo;</button>
                    </div>
                    <div class="panel">
                        <div class="panel-header">
                            <span class="panel-label">Assigned</span>
                            <span class="panel-count-badge badge-division">{{selectedDivisionList.length}}</span>
                        </div>
                        <input class="panel-search" placeholder="Search assigned..."
                            [(ngModel)]="assignedSearchDivision" [ngModelOptions]="{standalone: true}" />
                        <div class="panel-list">
                            @for (item of filterBySearch(selectedDivisionList, assignedSearchDivision); track item) {
                            <div class="list-item" [class.checked]="isCheckedAssigned(item, adminStructure.DIVISION)" (click)="toggleAssignedCheck(item, adminStructure.DIVISION)">
                                <span class="item-check"></span>
                                <span>{{item.name}}</span>
                            </div>
                            }
                        </div>
                        <div class="panel-footer">
                            <a class="action-link remove-link" (click)="removeAll(adminStructure.DIVISION)">&larr; Remove All</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- DISTRICT -->
            <div class="rights-section">
                <div class="section-header bg-district">
                    <span class="section-title">{{'DISTRICT' | translate}}</span>
                    @if (selectedDivisionList.length === 0) {
                    <span class="dependency-msg">Assign divisions first</span>
                    }
                </div>
                <div class="section-body" [class.disabled-section]="selectedDivisionList.length === 0">
                    <div class="panel">
                        <div class="panel-header">
                            <span class="panel-label">Available</span>
                            <span class="panel-count">({{displayDistrictList.length}})</span>
                        </div>
                        <input class="panel-search" placeholder="Search rights..."
                            [(ngModel)]="availableSearchDistrict" [ngModelOptions]="{standalone: true}" />
                        <div class="panel-list">
                            @for (item of filterBySearch(displayDistrictList, availableSearchDistrict); track item) {
                            <div class="list-item" [class.checked]="isCheckedAvailable(item, adminStructure.DISTRICT)" (click)="toggleAvailableCheck(item, adminStructure.DISTRICT)">
                                <span class="item-check"></span>
                                <span>{{item.name}}</span>
                            </div>
                            }
                        </div>
                        <div class="panel-footer">
                            <a class="action-link add-link" (click)="selectAll(adminStructure.DISTRICT)">Add All &rarr;</a>
                        </div>
                    </div>
                    <div class="transfer-controls">
                        <button class="arrow-btn arrow-right" (click)="moveToAssigned(adminStructure.DISTRICT)">&rsaquo;</button>
                        <button class="arrow-btn arrow-left" (click)="moveToAvailable(adminStructure.DISTRICT)">&lsaquo;</button>
                    </div>
                    <div class="panel">
                        <div class="panel-header">
                            <span class="panel-label">Assigned</span>
                            <span class="panel-count-badge badge-district">{{selectedDistrictList.length}}</span>
                        </div>
                        <input class="panel-search" placeholder="Search assigned..."
                            [(ngModel)]="assignedSearchDistrict" [ngModelOptions]="{standalone: true}" />
                        <div class="panel-list">
                            @for (item of filterBySearch(selectedDistrictList, assignedSearchDistrict); track item) {
                            <div class="list-item" [class.checked]="isCheckedAssigned(item, adminStructure.DISTRICT)" (click)="toggleAssignedCheck(item, adminStructure.DISTRICT)">
                                <span class="item-check"></span>
                                <span>{{item.name}}</span>
                            </div>
                            }
                        </div>
                        <div class="panel-footer">
                            <a class="action-link remove-link" (click)="removeAll(adminStructure.DISTRICT)">&larr; Remove All</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- TEHSIL -->
            <div class="rights-section">
                <div class="section-header bg-tehsil">
                    <span class="section-title">{{'TEHSIL' | translate}}</span>
                    @if (selectedDistrictList.length === 0) {
                    <span class="dependency-msg">Assign districts first</span>
                    }
                </div>
                <div class="section-body" [class.disabled-section]="selectedDistrictList.length === 0">
                    <div class="panel">
                        <div class="panel-header">
                            <span class="panel-label">Available</span>
                            <span class="panel-count">({{displayTehsilList.length}})</span>
                        </div>
                        <input class="panel-search" placeholder="Search rights..."
                            [(ngModel)]="availableSearchTehsil" [ngModelOptions]="{standalone: true}" />
                        <div class="panel-list">
                            @for (item of filterBySearch(displayTehsilList, availableSearchTehsil); track item) {
                            <div class="list-item" [class.checked]="isCheckedAvailable(item, adminStructure.TEHSIL)" (click)="toggleAvailableCheck(item, adminStructure.TEHSIL)">
                                <span class="item-check"></span>
                                <span>{{item.name}}</span>
                            </div>
                            }
                        </div>
                        <div class="panel-footer">
                            <a class="action-link add-link" (click)="selectAll(adminStructure.TEHSIL)">Add All &rarr;</a>
                        </div>
                    </div>
                    <div class="transfer-controls">
                        <button class="arrow-btn arrow-right" (click)="moveToAssigned(adminStructure.TEHSIL)">&rsaquo;</button>
                        <button class="arrow-btn arrow-left" (click)="moveToAvailable(adminStructure.TEHSIL)">&lsaquo;</button>
                    </div>
                    <div class="panel">
                        <div class="panel-header">
                            <span class="panel-label">Assigned</span>
                            <span class="panel-count-badge badge-tehsil">{{selectedTehsilList.length}}</span>
                        </div>
                        <input class="panel-search" placeholder="Search assigned..."
                            [(ngModel)]="assignedSearchTehsil" [ngModelOptions]="{standalone: true}" />
                        <div class="panel-list">
                            @for (item of filterBySearch(selectedTehsilList, assignedSearchTehsil); track item) {
                            <div class="list-item" [class.checked]="isCheckedAssigned(item, adminStructure.TEHSIL)" (click)="toggleAssignedCheck(item, adminStructure.TEHSIL)">
                                <span class="item-check"></span>
                                <span>{{item.name}}</span>
                            </div>
                            }
                        </div>
                        <div class="panel-footer">
                            <a class="action-link remove-link" (click)="removeAll(adminStructure.TEHSIL)">&larr; Remove All</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MOUZA -->
            <div class="rights-section">
                <div class="section-header bg-mouza">
                    <span class="section-title">{{'MOUZA' | translate}}</span>
                    @if (selectedTehsilList.length === 0) {
                    <span class="dependency-msg">Assign tehsils first</span>
                    }
                </div>
                <div class="section-body" [class.disabled-section]="selectedTehsilList.length === 0">
                    <div class="panel">
                        <div class="panel-header">
                            <span class="panel-label">Available</span>
                            <span class="panel-count">({{displayMouzaList.length}})</span>
                        </div>
                        <input class="panel-search" placeholder="Search rights..."
                            [(ngModel)]="availableSearchMouza" [ngModelOptions]="{standalone: true}" />
                        <div class="panel-list">
                            @for (item of filterBySearch(displayMouzaList, availableSearchMouza); track item) {
                            <div class="list-item" [class.checked]="isCheckedAvailable(item, adminStructure.MOUZA)" (click)="toggleAvailableCheck(item, adminStructure.MOUZA)">
                                <span class="item-check"></span>
                                <span>{{item.name}}</span>
                            </div>
                            }
                        </div>
                        <div class="panel-footer">
                            <a class="action-link add-link" (click)="selectAll(adminStructure.MOUZA)">Add All &rarr;</a>
                        </div>
                    </div>
                    <div class="transfer-controls">
                        <button class="arrow-btn arrow-right" (click)="moveToAssigned(adminStructure.MOUZA)">&rsaquo;</button>
                        <button class="arrow-btn arrow-left" (click)="moveToAvailable(adminStructure.MOUZA)">&lsaquo;</button>
                    </div>
                    <div class="panel">
                        <div class="panel-header">
                            <span class="panel-label">Assigned</span>
                            <span class="panel-count-badge badge-mouza">{{selectedMouzaList.length}}</span>
                        </div>
                        <input class="panel-search" placeholder="Search assigned..."
                            [(ngModel)]="assignedSearchMouza" [ngModelOptions]="{standalone: true}" />
                        <div class="panel-list">
                            @for (item of filterBySearch(selectedMouzaList, assignedSearchMouza); track item) {
                            <div class="list-item" [class.checked]="isCheckedAssigned(item, adminStructure.MOUZA)" (click)="toggleAssignedCheck(item, adminStructure.MOUZA)">
                                <span class="item-check"></span>
                                <span>{{item.name}}</span>
                            </div>
                            }
                        </div>
                        <div class="panel-footer">
                            <a class="action-link remove-link" (click)="removeAll(adminStructure.MOUZA)">&larr; Remove All</a>
                        </div>
                    </div>
                </div>
            </div>
            }
        </form>
    </mat-card-content>
</mat-card>
